import { render, staticRenderFns } from "./PlantInfoDetail.vue?vue&type=template&id=ad33b940"
import script from "./PlantInfoDetail.vue?vue&type=script&lang=ts"
export * from "./PlantInfoDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports